import { Row, Col, Card, Space, Statistic, Typography } from 'antd';
import { SimulationCard } from '../../../pages/Simulation/SimulationCard';
import { getColor } from '../../../pages/Simulation/utils';
import type { MarginSimulationReportData } from '../../../store/simulation/types';
const { Title } = Typography;
const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export interface SimulationMarginReportMarginRowProps {
  reportData: MarginSimulationReportData;
  loading: boolean;
}

export const SimulationMarginReportMarginRow = ({ reportData, loading }: SimulationMarginReportMarginRowProps) => (
  <SimulationCard
    subHeading="Details about margin between your sell rates and the simulated label costs"
    heading="Sell Rate Margins"
  >
    <Row style={{ marginBottom: 10 }} gutter={16}>
      <Col span={8}>
        <Card loading={loading} bordered={true} style={{ background: '#fafafa' }}>
          <Title level={4}>Average Sell Rate Margin (per shipment)</Title>
          <Space size={'large'}>
            <Statistic
              title={'Simulated'}
              value={currencyFormatter.format(reportData?.averageSellRateMargin)}
              precision={0}
              valueStyle={{
                color: getColor(reportData?.averageSellRateMargin),
              }}
            />
          </Space>
        </Card>
      </Col>
      <Col span={8}>
        <Card loading={loading} bordered={true} style={{ height: '100%', background: '#fafafa' }}>
          <Title level={4}>Total Sell Rate Margin</Title>
          <Space size={'large'}>
            <Statistic
              title={'Simulated'}
              value={currencyFormatter.format(reportData?.totalSellRateMargin)}
              precision={0}
              valueStyle={{
                color: getColor(reportData?.totalSellRateMargin),
              }}
            />
          </Space>
        </Card>
      </Col>
      <Col span={8}>
        <Card loading={loading} bordered={true} style={{ height: '100%', background: '#fafafa' }}>
          <Title level={4}>Sell Rate Margin Percentage</Title>
          <Space size={'large'}>
            <Statistic
              title={'Simulated'}
              value={`${reportData?.totalSellRateMarginPercent}%`}
              precision={0}
              valueStyle={{
                color: getColor(reportData?.totalSellRateMarginPercent),
              }}
            />
          </Space>
        </Card>
      </Col>
    </Row>
  </SimulationCard>
);
